const methy_DMR_GO_paths = {
    "CA12DAP_vs_CA15DAP": [
        "/api/static/methy/methy_GO/CA12DAP_vs_CA15DAP.CG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA12DAP_vs_CA15DAP.CHG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA12DAP_vs_CA15DAP.CHH.DMR_genes.Enriched_GO.bar_graph.png"
    ],
    "CA12DAP_vs_CA9DAP": [
        "/api/static/methy/methy_GO/CA12DAP_vs_CA9DAP.CG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA12DAP_vs_CA9DAP.CHG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA12DAP_vs_CA9DAP.CHH.DMR_genes.Enriched_GO.bar_graph.png"
    ],
    "CA12DAP_vs_ZY12DAP": [
        "/api/static/methy/methy_GO/CA12DAP_vs_ZY12DAP.CG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA12DAP_vs_ZY12DAP.CHG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA12DAP_vs_ZY12DAP.CHH.DMR_genes.Enriched_GO.bar_graph.png"
    ],
    "CA15DAP_vs_CA9DAP": [
        "/api/static/methy/methy_GO/CA15DAP_vs_CA9DAP.CG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA15DAP_vs_CA9DAP.CHG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA15DAP_vs_CA9DAP.CHH.DMR_genes.Enriched_GO.bar_graph.png"
    ],
    "CA15DAP_vs_ZY15DAP": [
        "/api/static/methy/methy_GO/CA15DAP_vs_ZY15DAP.CG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA15DAP_vs_ZY15DAP.CHG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA15DAP_vs_ZY15DAP.CHH.DMR_genes.Enriched_GO.bar_graph.png"
    ],
    "CA9DAP_vs_ZY9DAP": [
        "/api/static/methy/methy_GO/CA9DAP_vs_ZY9DAP.CG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA9DAP_vs_ZY9DAP.CHG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/CA9DAP_vs_ZY9DAP.CHH.DMR_genes.Enriched_GO.bar_graph.png"
    ],
    "ZY12DAP_vs_ZY15DAP": [
        "/api/static/methy/methy_GO/ZY12DAP_vs_ZY15DAP.CG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/ZY12DAP_vs_ZY15DAP.CHG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/ZY12DAP_vs_ZY15DAP.CHH.DMR_genes.Enriched_GO.bar_graph.png"
    ],
    "ZY12DAP_vs_ZY9DAP": [
        "/api/static/methy/methy_GO/ZY12DAP_vs_ZY9DAP.CG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/ZY12DAP_vs_ZY9DAP.CHG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/ZY12DAP_vs_ZY9DAP.CHH.DMR_genes.Enriched_GO.bar_graph.png"
    ],
    "ZY15DAP_vs_ZY9DAP": [
        "/api/static/methy/methy_GO/ZY15DAP_vs_ZY9DAP.CG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/ZY15DAP_vs_ZY9DAP.CHG.DMR_genes.Enriched_GO.bar_graph.png",
        "/api/static/methy/methy_GO/ZY15DAP_vs_ZY9DAP.CHH.DMR_genes.Enriched_GO.bar_graph.png"
    ]
}
export default methy_DMR_GO_paths